import { render, staticRenderFns } from "./OrganizationAuth.vue?vue&type=template&id=38f3de2c&scoped=true"
import script from "./OrganizationAuth.vue?vue&type=script&lang=js"
export * from "./OrganizationAuth.vue?vue&type=script&lang=js"
import style0 from "./OrganizationAuth.vue?vue&type=style&index=0&id=38f3de2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f3de2c",
  null
  
)

export default component.exports